import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const Container = styled.div`
  padding: 16px 12px;
  .hint {
    font-size: ${Variables.font_sizes.x1_medium};
    color: ${Variables.colors.complementary_700};
    line-height: 1.56;
    margin-bottom: 16px;
  }
`;

export const CardPanel = styled.div`
  padding: 8px 12px;
  margin-bottom: 16px;
  background-color: ${Variables.colors.complementary_50};
  box-shadow: 0 1px 6px 0 #ccc;
  border-radius: 10px;
  cursor: pointer;
  &:hover{
    background-color: ${Variables.colors.complementary_200};
  }
  .top-row {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    .role-icon {
      margin-left: 8px;

      &:before {
        font-size: 28px;
        color: ${Variables.colors.complementary_900};
      }
    }
    .panel-name {
      font-size: ${Variables.font_sizes.medium};
      color: ${Variables.colors.complementary_900};
    }
  }
  .bottom-row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .text {
      font-size: ${Variables.font_sizes.small};
      color: ${Variables.colors.tertiary_700};
    }
    .arrow-icon {
      margin-right: 4px;
      display: flex;
      &:before {
        font-size: 10px;
        color: ${Variables.colors.tertiary_700};
      }
    }
  }
`;
